import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Users } from "lucide-react";

export default function TourCard({ tour, index = 0 }) {
  return (
    <Link
      to={`/tours/${tour.slug}`}
      className="tour-card group block overflow-hidden"
      data-testid={`tour-card-${tour.slug}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[var(--bg-2)]">
        <img
          src={tour.image_url}
          alt={tour.title}
          className="tour-image w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-4 left-4">
          <span className="chip" data-testid={`tour-category-${tour.slug}`}>{tour.category}</span>
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-display text-2xl leading-tight">{tour.title}</h3>
          <ArrowUpRight
            size={20}
            className="shrink-0 mt-1 text-[var(--ink-soft)] group-hover:text-[var(--pine)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
          />
        </div>
        <p className="text-[var(--ink-soft)] text-sm mt-3 leading-relaxed line-clamp-2">{tour.short_description}</p>
        <div className="mt-5 pt-5 border-t border-[var(--border)] flex items-center justify-between text-sm text-[var(--ink-soft)]">
          <span className="flex items-center gap-1.5"><Clock size={14} /> {tour.duration}</span>
          <span className="flex items-center gap-1.5"><Users size={14} /> {tour.group_size}</span>
        </div>
      </div>
    </Link>
  );
}
